export function pricesFormat(num){
    let temporal=Number(num)
    return temporal.toFixed(2)
}

export default {pricesFormat}